// utils/api/DiscussionsApi.js
import { apiCall } from './ApiUtils';

export class DiscussionsApi {
  /**
   * Get all active users in the current class
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with active users
   */
  static async getActiveUsers(classContext) {
    return apiCall('/active-users', { method: 'GET' }, classContext);
  }

  /**
   * Get all feedback entries for a specific user
   * @param {string} username - The username to get feedback for
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with feedback entries
   */
  static async getUserFeedback(username, classContext) {
    return apiCall(`/user-feedback/${username}`, { method: 'GET' }, classContext);
  }

  /**
   * Get detailed feedback information for a specific feedback entry
   * @param {string} feedbackId - The feedback entry ID
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with detailed feedback information
   */
  static async getFeedbackDetails(feedbackId, classContext) {
    return apiCall(`/feedback-details-new/${feedbackId}`, { method: 'GET' }, classContext);
  }

  /**
   * Get discussion comments for a specific feedback entry
   * @param {string} feedbackId - The feedback entry ID
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with discussion comments
   */
  static async getDiscussions(feedbackId, classContext) {
    return apiCall(`/discussions/${feedbackId}`, { method: 'GET' }, classContext);
  }

  /**
   * Create a new discussion comment
   * @param {Object} discussionData - The discussion data containing feedbackId, username, text
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with creation result
   */
  static async createDiscussion(discussionData, classContext) {
    return apiCall('/discussions', {
      method: 'POST',
      body: JSON.stringify(discussionData)
    }, classContext);
  }

  /**
   * Get evaluation values for a specific feedback entry
   * @param {string} feedbackId - The feedback entry ID
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with evaluation values
   */
  static async getEvaluation(feedbackId, classContext) {
    return apiCall(`/evaluation/${feedbackId}`, { method: 'GET' }, classContext);
  }

  /**
   * Save evaluation values for a feedback entry
   * @param {Object} evaluationData - The evaluation data containing feedback_id and values
   * @param {Object} classContext - Class context with class_id and class_code
   * @returns {Promise} API response with save result
   */
  static async saveEvaluation(evaluationData, classContext) {
    return apiCall('/evaluation', {
      method: 'POST',
      body: JSON.stringify(evaluationData)
    }, classContext);
  }
}

export default DiscussionsApi;